import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { useTranslation } from "../../contexts/TranslationContext";
import "./theme-switcher.scss";

const ThemeSwitcher = ({ showLabel = true, compact = false }) => {
  const { currentTheme, currentThemeInfo, toggleTheme } = useTheme();
  const { language } = useTranslation();

  const handleThemeChange = () => {
    console.log('Theme switcher clicked, current theme:', currentTheme);
    toggleTheme();
  };

  const getThemeSwitchText = () => {
    const targetTheme = currentTheme === 'light' ? 'dark' : 'light';
    return language.themeSwitcher?.switchTo 
      ? `${language.themeSwitcher.switchTo} ${targetTheme} ${language.themeSwitcher.theme || 'theme'}`
      : `Switch to ${targetTheme} theme`;
  };

  return (
    <div className={`theme-switcher ${compact ? 'theme-switcher--compact' : ''}`}>
      <button
        className="theme-switcher__button"
        onClick={handleThemeChange}
        title={getThemeSwitchText()}
        aria-label={getThemeSwitchText()}
      >
        <i className={`fa ${currentThemeInfo.icon} theme-switcher__icon`} aria-hidden="true"></i>
        {showLabel && (
          <span className="theme-switcher__label">
            {currentThemeInfo.name}
          </span>
        )}
      </button>
    </div>
  );
};

export default ThemeSwitcher;
